// Lib
import React, { Fragment } from 'react';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

// Components
import Spinner from '../../../../Spinner';
import EditRequestButton from '../../../../Button/EditRequestButton';

// Constants
import {
  NO_METHODS,
  SHIPPING_SCHEDULE_WITH_DATES,
} from '../../../../../constants/cart';
import ErrorMessage from '../../../../Error/ErrorMessage';

// Styles
import { useStyles } from './ShippingMethodsStyles';

const ShippingMethods = ({
  loadingMethods,
  shippingDetails,
  openRequestCard,
  onChangeDetails,
  apiError,
}) => {
  const { classes } = useStyles();
  const { schedule, method, shippingRequest, date, methods } = shippingDetails;

  if (loadingMethods) {
    return <Spinner height="120px" />;
  }

  if (apiError) {
    return <ErrorMessage message={apiError} />;
  }

  if (SHIPPING_SCHEDULE_WITH_DATES.includes(schedule) && !date) {
    return <Box mb={2}>Please, Choose Date</Box>;
  }

  if (methods.length) {
    return (
      <RadioGroup
        className={classes.radioGroup}
        value={method?.name}
        row={false}
        aria-labelledby="address-format-radio-buttons-group-label"
        name="shipping-method-radio-buttons-group">
        {methods.map(({ label, value, escalation, id }) => (
          <Fragment key={label}>
            <FormControlLabel
              className={classes.radioLabel}
              value={value}
              control={
                <Radio
                  id={String(id)}
                  name={escalation ? 'requiredRequest' : ''}
                  classes={{
                    root: classes.radioItem,
                  }}
                  onChange={onChangeDetails('method')}
                />
              }
              label={label}
            />
            {value === method?.name && shippingRequest && escalation && (
              <EditRequestButton
                className={classes.editRequestButton}
                onClick={openRequestCard}
                title="Edit Shipping Request"
              />
            )}
          </Fragment>
        ))}
      </RadioGroup>
    );
  }

  return (
    <div data-testid="no-methods" className={classes.noMethods}>
      {NO_METHODS}
    </div>
  );
};

export default ShippingMethods;
